import axios from 'axios'
import { ElMessage } from 'element-plus'
import store from '@/store'
import router from '@/router'

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:8080/api',
  timeout: 30000
})

// 请求拦截
service.interceptors.request.use(
  config => {
    const token = store?.state?.token || localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截
service.interceptors.response.use(
  response => {
    const res = response.data
    
    // 业务层面的错误也返回完整res，让调用方处理
    if (res.code !== 200 && res.code !== 20000) {
      ElMessage.error(res.message || '操作失败')
    }
    
    return res
  },
  error => {
    console.error('响应错误:', error)
    
    if (error.response) {
      if (error.response.status === 401) {
        ElMessage.error('登录已过期，请重新登录')
        store?.dispatch('logout')
        router.push('/login')
      } else if (error.response.status === 403) {
        ElMessage.error('没有权限访问')
      } else {
        ElMessage.error(error.response.data?.message || '请求失败')
      }
    } else {
      ElMessage.error('网络连接失败')
    }
    
    return Promise.reject(error)
  }
)

export default service
